import React, { useState } from 'react';
import styles from './PhotosSection.module.css';
import ImageLightbox from './ImageLightbox';

const PHOTO_ORDER_KEY = 'talent-photo-order';

function PortfolioSection({ medias, profileId }) {
  const [lightboxUrl, setLightboxUrl] = useState(null);
  let photos = (medias || [])
    .filter(m => m.mediaType === 'IMAGE' && m.photoType === 'PORTFOLIO' && m.url)
    .slice(0, 4);

  if (profileId) {
    try {
      const raw = localStorage.getItem(PHOTO_ORDER_KEY);
      const all = raw ? JSON.parse(raw) : {};
      const savedOrder = all[String(profileId)] || [];
      if (savedOrder.length > 0) {
        const rank = new Map(savedOrder.map((key, index) => [String(key), index]));
        photos = [...photos].sort((a, b) => {
          const aRank = rank.has(String(a.id ?? a.url)) ? rank.get(String(a.id ?? a.url)) : Number.MAX_SAFE_INTEGER;
          const bRank = rank.has(String(b.id ?? b.url)) ? rank.get(String(b.id ?? b.url)) : Number.MAX_SAFE_INTEGER;
          return aRank - bRank;
        });
      }
    } catch {}
  }

  const slots = [...photos, ...Array(Math.max(0, 4 - photos.length)).fill(null)];

  if (photos.length === 0) return null;

  return (
    <>
    <div className={styles.container}>
      <span className={styles.sectionTitle}>사진 포트폴리오</span>
      <div className={styles.card}>
        <div className={styles.grid}>
          {slots.map((photo, i) => (
            <div key={i} className={styles.photoBox}>
              {photo && (
                <img
                  src={photo.url}
                  alt={`포트폴리오 사진 ${i + 1}`}
                  onClick={() => setLightboxUrl(photo.url)}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '10px', cursor: 'pointer' }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>

    <ImageLightbox url={lightboxUrl} alt="포트폴리오 사진" onClose={() => setLightboxUrl(null)} />
    </>
  );
}

export default PortfolioSection;
